import { TableBody, TableCell, TableRow, Badge } from '@/components/ui';
import { DataTableBodyCellDate, TableCellRowLine } from '@/components/custom';
import DataTableBodyCellOptions from './DataTableBodyCellOptions';
import { usePaymentMethodRequests } from '../../hooks';
import { PaymentMethodRequestStatusEnum } from '@/enums';
import { cn } from '@/lib/utils';

const PAYMENT_METHOD_REQUEST_STATUS_CONFIG: Record<PaymentMethodRequestStatusEnum, { label: string; className: string }> = {
  [PaymentMethodRequestStatusEnum.NEW]:         { label: 'Nouveau',     className: 'bg-blue-100 text-blue-700 hover:bg-blue-100' },
  [PaymentMethodRequestStatusEnum.SEEN]:        { label: 'Vu',          className: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-100' },
  [PaymentMethodRequestStatusEnum.IMPLEMENTED]: { label: 'Implémenté', className: 'bg-green-100 text-green-700 hover:bg-green-100' },
};

export const DataTableBody = () => {

  const { paymentMethodRequests } = usePaymentMethodRequests();

  return (
    <TableBody>
      {
        [...paymentMethodRequests]
          .map(
            (request, index) => (
              <TableRow key={request._id} className='h-10'>
                <TableCellRowLine value={index + 1} />
                <TableCell className='py-1 font-medium'>
                  {request.username}
                </TableCell>
                <TableCell className='py-1 text-muted-foreground'>
                  {request.country}
                </TableCell>
                <TableCell className='py-1 text-purple-600 font-medium'>
                  {request.paymentMethod}
                </TableCell>
                <TableCell className='py-1'>
                  <Badge className={cn('text-xs font-medium', PAYMENT_METHOD_REQUEST_STATUS_CONFIG[request.status].className)}>
                    {PAYMENT_METHOD_REQUEST_STATUS_CONFIG[request.status].label}
                  </Badge>
                </TableCell>
                <DataTableBodyCellDate date={request.createdAt} className='py-1' format='DD MMM YYYY' />
                <DataTableBodyCellOptions request={request} />
              </TableRow>
            )
          )
      }
    </TableBody>
  );

};

export default DataTableBody;
